import {Service} from "@/services/superclasses/service";
import {MemberContactList} from "@/interfaces/member-contact-list";

const api = window.contextPath + '/rest/member-contacts';

export class MemberContactService extends Service {

    public search = async (args: {
        member?: number,
        q?: string,
        featured?: boolean,
        first?: number,
        max?: number
    }): Promise<MemberContactList[]> => {
        return this.data(await this.get<MemberContactList[]>(api + "/",
            {
                params: args
            }))
    }
}

export const memberContactService = new MemberContactService()